import { type ApplicationSteps, type PartialRecord } from 'share/types'
import { UserRecord } from 'share/types/model/user'
import { pathnames } from 'utils/constants'

export const getOwnProgramPaths = (key: ApplicationSteps, needSpouseConsent: boolean) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    // Main pages
    UPDATE_LOAN_DATA_IN_TELEMARKETING: pathnames['internal-step-loader'],
    FETCH_DDOCS: pathnames['digital-doc'],

    // Colvir
    OPEN_FL_CARD: pathnames['open-borrower-account'],
    OPEN_UL_CARD: pathnames['open-borrower-account'],
    OPEN_BORROWER_ACCOUNT: pathnames['open-borrower-account'],

    CHECK_TAX_DEBT: pathnames['own-debt'],

    UPLOAD_BANK_DATA_IN_TELEMARKETING: pathnames['open-borrower-account'],
    SET_PAY_DAY: pathnames['documents-sign'],
    // FETCH_OWN_PROGRAM_SPOUSE_PERSONAL_INFO: needSpouseConsent

    FETCH_SPOUSE_PERSONAL_INFO_FOR_CONSENT: needSpouseConsent
      ? pathnames['spouse-confirmation']
      : pathnames['documents-sign'],
    GET_CORP_CARD_DATA: pathnames['documents-sign'],
    REGISTER_IN_COLVIR: pathnames['documents-sign'],
    GENERATE_MAIN_DOCUMENTS: pathnames['documents-sign'],
    GENERATE_DOCUMENTS_SIGNED_BY_ECP: pathnames['documents-sign'],
    CREATE_APPLICATION_IN_CRED_ADMIN: pathnames['documents-sign'],
    WAIT_FOR_CONFIRMATION_FROM_CRED_ADMIN: pathnames['documents-sign'],
    CHECK_DAILY_LIMIT: pathnames['documents-sign'],
    Q19_CALL: pathnames['q19-call'],
    SIGN_SPOUSE_DOCS_AITU: pathnames['internal-step-loader'],
    SEND_SPOUSE_SIGNING_SMS: pathnames['internal-step-loader'],
    SIGN_DOCS_AITU: pathnames['documents-sign'],

    // Spouse certification center signing steps
    ACQUAINTANCE_SPOUSE_WITH_DOCUMENTS: pathnames['internal-step-loader'],
    SPOUSE_BIOMETRY_FORENSICS: pathnames['internal-step-loader'],
    SEND_SPOUSE_OTP_SMS: pathnames['internal-step-loader'],
    SIGN_SPOUSE_DOCS_CERTIFICATION_CENTER: pathnames['internal-step-loader'],

    // Certification center steps
    ACQUAINTANCE_WITH_DOCUMENTS: pathnames['documents-sign'],
    SIGN_BIOMETRY_FORENSICS: pathnames['certification-center'],
    SEND_OTP_SMS: pathnames['certification-center'],
    SIGN_OWN_DOCS_CERTIFICATION_CENTER: pathnames['internal-step-loader'],
    SIGN_BANK_LOAN_AGREEMENT_BY_BANK: pathnames['internal-step-loader'],
    SIGN_REPAYMENT_SCHEDULE_BY_BANK: pathnames['internal-step-loader'],
    WAIT_FOR_SIGNATURES_VALIDATION_FROM_CRED_ADMIN: pathnames['internal-step-loader'],
    LOAN_ACTUALIZE: pathnames['internal-step-loader'],

    // When current step is null
    // FETCH_SPOUSE_PERSONAL_INFO: pathnames['pledge-spouse-confirmation'],
    CHECKING_DOCUMENTS: pathnames['pledge-documents-upload']
  }
  return paths[key]
}

export const getPledgeFlowPaths = (key: ApplicationSteps, maritalStatus: UserRecord['marital_status']) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    UPDATE_LOAN_DATA_IN_TELEMARKETING: pathnames['internal-step-loader'],

    FETCH_DDOCS: pathnames['digital-doc'],
    // CHECKING_DOCUMENTS: pathnames['pledge-documents-upload'],
    CHECKING_COLLATERAL:
      maritalStatus === 'MARRIED' ? pathnames['internal-step-loader'] : pathnames['open-borrower-account'],
    CREATE_ESTIMATION: pathnames['open-borrower-account'],
    AWAITING_CREDIT_MANAGER_DECISION: pathnames['open-borrower-account'],
    DECISION_LAWYER: pathnames['open-borrower-account'],
    DECISION_COLLATERAL: pathnames['open-borrower-account'],
    OPEN_FL_CARD: pathnames['open-borrower-account'],
    OPEN_UL_CARD: pathnames['open-borrower-account'],
    OPEN_BORROWER_ACCOUNT: pathnames['open-borrower-account'],
    CHECK_TAX_DEBT: pathnames['own-debt'],

    PAYBOX_COMISSION_FEE_PAYMENT: pathnames['pledge-fee-payment'],
    SET_PAY_DAY: pathnames['documents-sign'],
    GET_CORP_CARD_DATA: pathnames['documents-sign'],
    DECISION_ESTIMATOR: pathnames['documents-sign'],
    REGISTER_IN_COLVIR: pathnames['documents-sign'],
    COLVIR_MORTGAGE: pathnames['documents-sign'],
    GENERATE_MAIN_DOCUMENTS: pathnames['documents-sign'],
    GENERATE_DOCUMENTS_SIGNED_BY_ECP: pathnames['documents-sign'],
    CREATE_APPLICATION_IN_CRED_ADMIN: pathnames['documents-sign'],
    WAIT_FOR_CONFIRMATION_FROM_CRED_ADMIN: pathnames['documents-sign'],
    CHECK_DAILY_LIMIT: pathnames['documents-sign'],
    GENERATE_CONCLUSION_ON_COLLATERAL: pathnames['documents-sign'],
    ACQUAINTANCE_WITH_DOCUMENTS: pathnames['documents-sign'],

    // Certification center steps
    SIGN_BIOMETRY_FORENSICS: pathnames['certification-center'],
    SEND_OTP_SMS: pathnames['certification-center'],
    SIGN_PLEDGE_DOCS_CERTIFICATION_CENTER: pathnames['internal-step-loader'],
    SEND_CERT_CENTER_SIGNATURES: pathnames['internal-step-loader'],
    BLOCKCHAIN_CREATE_RECORD: pathnames['internal-step-loader'],

    // DOCUMENT_SIGNING_AND_VERIFICATION: pathnames['documents-sign'],
    // SEND_PLEDGE_AGREEMENTS_CLIENT_SIGNATURE_TO_CRED_ADMIN: pathnames['documents-sign'],
    // SIGN_DOCS_AITU_PLEDGE: pathnames['documents-sign'],
    SEND_MAIN_DOCUMENTS_CLIENTS_SIGNATURE_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    SIGN_BANK_LOAN_AGREEMENT_BY_BANK: pathnames['internal-step-loader'],
    SEND_BANK_LOAN_AGREEMENTS_BANK_SIGNATURE_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    SIGN_REPAYMENT_SCHEDULE_BY_BANK: pathnames['internal-step-loader'],
    WAIT_FOR_SIGNATURES_VALIDATION_FROM_CRED_ADMIN: pathnames['internal-step-loader'],
    SEND_BANK_REPAYMENT_SCHEDULE_SIGNATURE_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    SIGN_PLEDGE_AGREEMENT_BY_BANK: pathnames['internal-step-loader'],
    SEND_PLEDGE_AGREEMENTS_BANK_SIGNATURE_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    LOAN_ACTUALIZE: pathnames['internal-step-loader']
  }
  return paths[key]
}

export const getOwnProgramAutoPaths = (key: ApplicationSteps, needSpouseConsent: boolean) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    UPDATE_LOAN_DATA_IN_TELEMARKETING: pathnames['internal-step-loader'],
    FETCH_DDOCS: pathnames['digital-doc'],
    CREATE_APPLICATION_IN_CRED_ADMIN: pathnames['internal-step-loader'],

    // Colvir
    OPEN_FL_CARD: pathnames['open-borrower-account'],
    OPEN_UL_CARD: pathnames['open-borrower-account'],
    OPEN_BORROWER_ACCOUNT: pathnames['open-borrower-account'],

    GENERATE_OPENING_ACCOUNT_DOCUMENTS: pathnames['internal-step-loader'],
    UPLOAD_BANK_DATA_IN_TELEMARKETING: pathnames['internal-step-loader'],
    SEND_BANK_DATA_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    CHECK_TAX_DEBT: pathnames['own-debt'],

    SET_PAY_DAY: pathnames['documents-sign'],
    // FETCH_OWN_PROGRAM_SPOUSE_PERSONAL_INFO: needSpouseConsent
    FETCH_SPOUSE_PERSONAL_INFO_FOR_CONSENT: needSpouseConsent
      ? pathnames['spouse-confirmation']
      : pathnames['documents-sign'],
    GET_CORP_CARD_DATA: pathnames['documents-sign'],
    REGISTER_IN_COLVIR: pathnames['documents-sign'],
    SEND_LOAN_DATA_TO_CRED_ADMIN: pathnames['internal-step-loader'],
    GENERATE_MAIN_DOCUMENTS: pathnames['documents-sign'],
    GENERATE_DOCUMENTS_SIGNED_BY_ECP: pathnames['documents-sign'],
    CHECK_DAILY_LIMIT: pathnames['documents-sign'],
    WAIT_FOR_CONFIRMATION_FROM_CRED_ADMIN: pathnames['documents-sign'],
    Q19_CALL: pathnames['q19-call'],
    SIGN_SPOUSE_DOCS_AITU: pathnames['internal-step-loader'],
    SIGN_DOCS_AITU: pathnames['documents-sign'],

    // Spouse certification center signing steps
    SEND_SPOUSE_SIGNING_SMS: pathnames['internal-step-loader'],
    ACQUAINTANCE_SPOUSE_WITH_DOCUMENTS: pathnames['internal-step-loader'],
    SPOUSE_BIOMETRY_FORENSICS: pathnames['internal-step-loader'],
    SEND_SPOUSE_OTP_SMS: pathnames['internal-step-loader'],
    SIGN_SPOUSE_DOCS_CERTIFICATION_CENTER: pathnames['internal-step-loader'],

    // Certification center steps
    ACQUAINTANCE_WITH_DOCUMENTS: pathnames['documents-sign'],
    SIGN_BIOMETRY_FORENSICS: pathnames['certification-center'],
    SEND_OTP_SMS: pathnames['certification-center'],
    SIGN_OWN_DOCS_CERTIFICATION_CENTER: pathnames['internal-step-loader'],
    SIGN_BANK_LOAN_AGREEMENT_BY_BANK: pathnames['internal-step-loader'],
    SIGN_REPAYMENT_SCHEDULE_BY_BANK: pathnames['internal-step-loader'],
    WAIT_FOR_SIGNATURES_VALIDATION_FROM_CRED_ADMIN: pathnames['internal-step-loader'],
    LOAN_ACTUALIZE: pathnames['internal-step-loader']
  }
  return paths[key]
}

export const getImprovePledgeFlowPaths = (key: ApplicationSteps) => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    APPROVE_PROPERTY_PLEDGES: pathnames.decision,
    SCORING: pathnames['scoring-loader'],
    PROPERTY_PLEDGES: pathnames['scoring-loader'],
    DECISION: pathnames.decision
  }

  return paths[key]
}
